import { lazy, Suspense } from 'react';
import { NotFoundErrorPage } from '@bizzabo/design-system';

import useIsCommunityEnabled from './hooks/useIsCommunityeEnabled';

const CardsView = lazy(() => import('./Community/CardsView'));

export const CommunityPage: React.FC<{ eventUniqueName: string }> = ({ eventUniqueName }) => {
    const isCommunityEnabled = useIsCommunityEnabled(eventUniqueName);

    return isCommunityEnabled ? (
        <Suspense fallback={null}>
            <CardsView />
        </Suspense>
    ) : (
        <NotFoundErrorPage />
    );
};

export default CommunityPage;
